import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-ui-elements',
  templateUrl: 'ui-elements.component.html',
  styleUrls: ['ui-elements.component.scss'],
  standalone: false
})
export class UIElementsComponent implements OnInit {
  // ----- ------- -----
  // ----- TOOLTIP -----
  // ----- ------- -----
  content =
    "Ta performance durant la période après frais et remboursements <a href='https://help.inyova.ch/hc/fr/articles/360011076740-Comment-le-rendement-de-mon-portefeuille-est-il-calcul%C3%A9-' target='_blank'>(retour pondéré dans le temps)</a>";

  title = 'Title for this tooltip';
  size: 'small' | 'medium' | 'large' = 'medium';

  // ----- --------- -----
  // ----- ERROR BOX -----
  // ----- --------- -----
  randomDescription =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam odio lacus, auctor sit amet egestas at, mattis ut ante. Etiam commodo feugiat elementum.';

  randomDescriptionShort = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.';

  randomDescriptionLong =
    '<span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam odio lacus, auctor sit amet egestas at, mattis ut ante. Etiam commodo feugiat elementum.</span><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam odio lacus, auctor sit amet egestas at, mattis ut ante. Etiam commodo feugiat elementum.</span>';

  randomActionDescription = 'I understand and would like to continue with an investment horizon of less than 5 years.';
  randomActionDescriptionLong =
    '<span>I understand and would like to continue with an investment horizon of less than 5 years.</span><span>I understand and would like to continue with an investment horizon of less than 5 years.</span>';

  checkboxStatusOne = false;
  checkboxStatusTwo = false;
  checkboxStatusThree = false;

  // ----- --------- -----
  // ----- SINGLE CHECKBOX -----
  // ----- --------- -----

  randomLabel = 'Label text';
  randomLabelLong =
    'LabeltextLabel textLabeltext LabeltextLabeltextLabel textLabeltextLabeltext LabeltextLabeltext LabeltextLabel textLabel textLabel textLabeltextL abeltext';

  singleCheckboxStatusOne = true;
  singleCheckboxStatusOneLong = false;
  singleCheckboxStatusTwo = false;
  singleCheckboxStatusTwoLong = false;
  singleCheckboxStatusThree = false;
  singleCheckboxStatusFour = false;
  errorStateCheckbox = true;
  id1 = '1';
  id2 = '2';
  id3 = '3';
  id4 = '4';
  id5 = '5';
  id6 = '6';

  radioButtonExample = 0;
  radioGroupForm: FormGroup;
  checkboxGroup: (string | number)[] = ['mirko'];
  checkboxGroup2: FormControl = new FormControl([3]);
  checkboxForm: FormGroup;
  checkboxGroupForm: FormGroup;
  checkboxGroupForm2: FormGroup;
  checkboxItems: { value: string; label: string }[] = [
    { value: 'mirko', label: 'His name is Mirko' },
    { value: 'slavko', label: 'I think his name is Slavko' },
    {
      value: 'darko',
      label: 'How are you Darko? Nice to meet you, How are you Darko? Nice to meet you, How are you Darko? Nice to meet you'
    }
  ];

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.radioGroupForm = this.fb.group({
      radio: [null, Validators.required]
    });
    this.checkboxForm = this.fb.group({
      iLoveYou: [false]
    });
    this.checkboxGroupForm = this.fb.group({
      checkboxGroup: [[], Validators.required]
    });
    this.checkboxGroupForm2 = this.fb.group({
      checkboxGroup: [['slavko'], Validators.required]
    });
  }
}
